const { gsap } = require('gsap');
import { ScrollTrigger }        from "gsap/ScrollTrigger";

const windowScrollPage = function () {

	//-> header small header
	const scrollHeader = () => {
		ScrollTrigger.create({
			trigger : '#webdoor',
			start: 'bottom center',
			end: 99999,
			toggleClass: {className: 'scrolling', targets: '#header, #webdoor'},
			// markers : true
		  });		  
	}

	const scrollFale = () => {
		ScrollTrigger.create({
			trigger : '#webdoor',
			start: '10% top',
			end: 99999,
			toggleClass: {className: 'scrolling', targets: '#fale-bt-link'},
			// markers : true
		  });		  
	}

	//-> parallax webdoor
	const parallaxWebdoor = function (el) {

		gsap.fromTo($(el).not(".no-plx").find('picture'),
			{
				yPercent: 0,
				scale: 1,
			}, {
			yPercent: 35,
			scale: 1.6,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top top",
				end: "bottom -=50%",
				scrub: true,

			}
		});

	}

	//-> bg transition scroll View
	const bgTransitionInView = (classBg) => {
		const bgChange = gsap.utils.toArray(classBg);
		bgChange.forEach((bgs) => {
			gsap.from(bgs, {
				scrollTrigger: {
					start: 'top 65%',
					end: 'bottom top',
					trigger: bgs,
					toggleClass: 'in-view'
				}
			});
		});
	}

	//-> fade-In Element in scroll View
	const showFade = (classFade) => {
		const bgChange = gsap.utils.toArray(classFade);
		bgChange.forEach((elmFade) => {
			gsap.from(elmFade, {
				scrollTrigger: {
					start: 'top 75%',
					end: '+=100%',
					trigger: elmFade,
					toggleClass: 'in-view',
					// markers : true
				}
			});
		});
	}

	//-> layer image in scroll View
	const layerImg = (classLImg, classIText) => {
		const bgChange = gsap.utils.toArray(classLImg);
		bgChange.forEach((classLImg) => {
			gsap.from(classLImg, {
				scrollTrigger: {
					start: 'top center',
					//end: '+=100%',
					trigger: classLImg,
					toggleClass: 'in-view',
					// markers : true
				}
			});
			const introText = gsap.utils.toArray(classIText);
			introText.forEach((intTxt) => {
				gsap.from(intTxt, {
					scrollTrigger: {
						start: 'center 80%',
						end: '+=100%',
						trigger: intTxt,
						toggleClass: 'in-view',
						// markers : true
					}
				});
			});
		});
	}

	const textCabral = () => {

		if(screen.width < 992) return;
		
		gsap.fromTo("#txtCloned",
			{
				width: '100%'
			}, {
			width: '0%',
			ease: "none",
			scrollTrigger: {
				trigger: "#section-cabral",
				start: "top 50%",
				end: "+=45%",
				scrub: 1,
				// markers : true
			}
		});
		gsap.fromTo("#text-abs",
			{
				yPercent: 100,
				scale : 1.2
			}, {
			yPercent: -50,
			scale : 1,
			ease: "none",
			scrollTrigger: {
				trigger: "#section-cabral",
				start: "center 80%",
				end: "+=25%",
				scrub: 2,
				// markers : true
			}
		});
	}

	const plxImage = () => {

		if(screen.width < 992) return;
		// console.log('nao eh mobile');

		gsap.utils.toArray(".wrap-img-parallax img").forEach((section, i) => {

			const heightDiff = section.offsetHeight - section.parentElement.offsetHeight;

			gsap.fromTo(section, {
				y: 0
			}, {
				y: -(heightDiff + 100),
				ease: "none",
				scrollTrigger: {
					start : 'top center',
					// end : 'center center',
					trigger: section.parentElement,
					scrub: true,
					invalidateOnRefresh: true,
					// markers : true
				}
			});
		});
	}


	const elmToScroll = function (el) {
        var _this = el.attr('data-scrollto');
        
        if($(window).width() < 1000) {
            $("#nav-header, #bt-menu-mobile").removeClass('motion-in');
        }
        scrollToElm(_this);


    }

    const scrollToElm = function (target) {
		var offSTop = document.getElementById('header').clientHeight;
		if(target == '#section-projetos') {
			if($(window).width() > 1200) {
				offSTop = 0;
			}
		}

        gsap.to(window, {
            duration : 2,
            scrollTo:{y:$(target).offset().top - ( $(window).width() > 1200 ? offSTop : offSTop )},//scrollTo end bracket
            delay:0,
            ease:'Power4.easeInOut'
        });
        // gsap.to(window, {
        //     duration: 1,
        //     scrollTo: document.querySelector(target).offsetTop , //- document.querySelector('header').clientHeight
        //     ease: 'Expo.easeOut',
        // }
        //);
    }

	//-> fade-In Element in scroll View
	const animateGraphisBar = (classFade) => {

/* 		gsap.fromTo(section, {
			y: 0
		}, {
			y: -(heightDiff + 100),
			ease: "none",
			scrollTrigger: {
				start : 'top center',
				// end : 'center center',
				trigger: section.parentElement,
				scrub: true,
				invalidateOnRefresh: true,
				// markers : true
			}
		}); */

		const barWidth = gsap.utils.toArray(classFade);
		barWidth.forEach((elmBar) => {
			gsap.fromTo(elmBar, {
				width : 0 
			}, {
				width : $(elmBar).attr('data-porcent'),	
				ease: "none",		
				scrollTrigger: {
					start: 'top 80%',
					end: 'bottom bottom',
					trigger: elmBar,
					scrub: 2,
					// toggleClass: 'in-view',
					// markers : true
				}
			});
		});
	}

	return {
		init: () => {

			scrollHeader();

			if ($(".webdoor").length > 0)
				parallaxWebdoor(".webdoor");

			if ($(".wrap-img-parallax").length > 0)
				plxImage();

			if ($('.bg-transition').length > 0)
				bgTransitionInView('.bg-transition');

			if ($('.showFade').length > 0)
				showFade('.showFade');

			if ($('.wrap-picture-img-parallax').length > 0)
				layerImg('.wrap-picture-img-parallax', '.text-intro');
			
			if ($('#txtCloned').length > 0)
				textCabral();
			
			if ($('.bar-porcent').length > 0)
				setTimeout(() => {
					animateGraphisBar('.bar-porcent');
				}, 1000);

			scrollFale();

			$(document).on('click', '[data-scrollto]', function (e) {
				e.preventDefault();
                elmToScroll($(this));
            });

			//marcar menu
			

			/* 			if($('.text-intro').length > 0)
							introText('.text-intro');
			 */


		}
	}

}();

export default windowScrollPage;